import { IEnvironment } from '@common/interfaces/environment.interface';

/* eslint-disable @typescript-eslint/naming-convention */
export const environment: IEnvironment = {
  PRODUCTION: false,
  USING_MOCKS: false,
  MOCK_SUCCESS_RATE: 1,
  MOCK_DELAY_MILISECONDS: 1000,
  ENV: 'dev',
  TCV_SITE: 'http://34.117.228.29',
  RECAPTCHA_SITE_KEY: '6Lf5piQaAAAAAFQbicFItib1BdWbDNHJJ41rzPU4',
  BASE_BACKEND: 'http://34.117.224.236',
  GOOGLE_MAPS_API_KEY: 'AIzaSyCZtfZiAKWUPDi1d17hDW2R2tiP2VpQshw',
  BASE_CMS: 'https://solventa-credit-cms-headless-dev-qeyw2abo5a-uk.a.run.app'
};
